import { render, staticRenderFns } from "./ToBeImproved.vue?vue&type=template&id=3ed6c60f&"
import script from "./ToBeImproved.vue?vue&type=script&lang=js&"
export * from "./ToBeImproved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports